export const environment = {
    production: false,
    apiBaseUrl: 'https://dev-asse-api.iapmo.org/',
    mediaBaseUrl: 'https://scb-media.iapmo.org/',
    documentGeneratorBaseUrl: 'https://generator-dev.iapmo.org/',
    msalClientId: 'aaecebd0-3c0f-4e59-a0cb-660e5175ae0a',
    msalTenantId: '21931cb4-d51f-475c-ad31-98d48783abce',
    redirectUri: 'https://dev-asse.iapmo.org/auth-callback',
};
